import { Controller } from '@hotwired/stimulus';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

// The autoplay attribute has usually started playback before connect, so stopping it means pausing, not just unsetting autoplay.
export default class extends Controller {
  connect() {
    if (!window.matchMedia(REDUCED_MOTION_QUERY).matches) return;

    this.element.autoplay = false;
    this.element.pause();
    this.element.controls = true;
  }
}
